import Module from '../../../packages/helper/module/index'
import Api from '../../../packages/helper/api/index'
import request from '../../api/request'

export default new Module('item', new Api(request, {
  list: '/api/item/list',
  one: '/api/item/details',
  add: '/api/item/add',
  update: '/api/item/modify'
}))



// WEBPACK FOOTER //
// ./examples/store/modules/item.js